module.exports = __webpack_public_path__ + "img/sprinkle-23.a36985c0.webp";